import {api} from "./axios"

const apiRequest = async ( query , variables = {})=>{
    try{
        //console.log("Enviando GraphQL Request:", { query, variables }); 
        const response = await api.post("", {
            query ,
            variables,
        });
        //console.log('aaa' ,response.data)
        return response.data;
    } catch (error) {
        console.error("Error en la solicitud Graphql: ",error);
        throw error;
    }
};

const apiRequests = async (query , variables = {}) =>{
    try {
        let requestData;
        let headers = {};
        const hasFile = Object.values(variables).some(value => value instanceof File);
        if(hasFile){
            requestData = new FormData();
            requestData.append("operations",JSON.stringify({query,variables}));
            const map = {};
            let fileIndex = 0;
            Object.keys(variables).forEach(key => {
                if (variables[key] instanceof File) {
                    map[fileIndex] = [`variables.${key}`];
                    requestData.append(fileIndex.toString(), variables[key]); // Agregar archivo a FormData
                    fileIndex++;
                }
            });

            requestData.append("map", JSON.stringify(map));
            headers["Content-Type"] = "multipart/form-data";
        }else{
            requestData = JSON.stringify({ query, variables });
            headers["Content-Type"] = "application/json";
        }
        const response = await api.post("", requestData, { headers });
        return response.data;
    } catch (error) {
        console.error("❌ Error en la solicitud GraphQL:", error);
        throw error;
    }
}
export { apiRequest , apiRequests};
